import { defineComponent as _defineComponent } from 'vue'
import { __ } from '@@/bits/intl'


export default /*#__PURE__*/_defineComponent({
  __name: 'ContentPickerSearchSuggestions',
  props: {
    searchSuggestions: null,
    xTitleDivider: { type: Boolean, default: true }
  },
  emits: ["suggestion-selected"],
  setup(__props: any, { emit }: { emit: ({
  (name: 'suggestion-selected', suggestion: string): void
}), expose: any, slots: any, attrs: any }) {





return { __sfc: true,emit, __ }
}

})